/** @jsxImportSource @emotion/react */
import { styleguideColors as COLORS, styleguideFontSize as FONT_SIZE, styleguideFontWeight as FONT_WEIGHT } from '@/Client/Styles/kaiShikiTokens';
import { pxToRem } from '@/Client/Styles/pxToRem';
import { css, SerializedStyles } from '@emotion/react';
import { styleguideFontFamily as FONT } from '@kaiizen/kai-shiki/core';

export type MetaListStyles = {
  root: SerializedStyles;
  separator: SerializedStyles;
};

export const DEFAULT_META_LIST_STYLES: MetaListStyles = {
  root: css`
    label: META_LIST;
    flex-shrink: 0;
    font-family: ${FONT.mono};
    font-size: ${pxToRem(FONT_SIZE.monoCaption)};
    font-weight: ${FONT_WEIGHT.bold};
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: ${COLORS.textTertiary};
    white-space: nowrap;
    font-variant-numeric: tabular-nums;
  `,
  separator: css`
    label: META_LIST_SEP,
    position: relative;
    &::before {
        content: '·';
        margin: 0 5px;
        color: inherit;
    }
  `,
};
